/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import PageHeader from "@components/PageHeader"
import PageFooter from "@components/PageFooter"
import "./layout.css"
import "@styles/custom-bootstrap.scss"
import "@styles/global.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div
        style={{
            minHeight: `100vh`,
            position: `relative`,
          }}>
        <PageHeader siteTitle={data.site.siteMetadata?.title || `Title`} />
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0 1.0875rem 1.45rem`,
            paddingBottom: `160px`,
            display: `flex`,
            flexFlow: `column`,
            height: `100%`,
          }}
        >
          <div style={{
            flex: `1 1 auto`,
          }}>
            <main>{children}</main>
          </div>
        </div>
        <PageFooter siteTitle={data.site.siteMetadata?.title || `Title`} /> 
      </div> 
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
